import { providerFaq, type RateFaq } from "@Light/components/rateOffer";

export const enrollmentFaqs = (companyName: string): RateFaq[] => [
  {
    question: "What do I need to do to switch?",
    answer: (
      <>
        Answer a few questions and we’ll handle the switch for you. Afterwards,
        you’ll pay your final bill with your current provider and you're all
        set.
      </>
    ),
  },
  providerFaq(companyName),
  {
    question: "How much will I be charged today?",
    answer: (
      <>
        Nothing. Your payment method is securely saved and billed on your first
        statement.
      </>
    ),
  },
];
